import React from "react";
import { TrashIconGray } from "../../constant/imagePath";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import classes from "./ImageAndVideoBoxWithDeleteBtn.module.css";

export function ImageAndVideoBoxWithDeleteBtn({ state, setter, item }) {
  function removePhotoOrVideo(data) {
    const newArr = state.slice();
    const index = newArr.findIndex((item) => item?.name === data.name);
    if (index !== -1) {
      newArr.splice(index, 1);
      setter(newArr);
    }
  }

  const mediaType = item?.type?.split("/")[1];
  const isImage =
    mediaType === "png" || mediaType === "jpeg" || mediaType === "svg+xml";
  const isVideo =
    mediaType === "mp4" || mediaType === "mov" || mediaType === "avi";

  return (
    <>
      <style jsx>{`
        .${classes.imageCard}::before {
          background-color: ${Colors.neutralShadesOfNero}80;
        }
      `}</style>
      {isImage && (
        <div className={classes.multipleImageCard}>
          <img src={URL.createObjectURL(item)} />
          <div className={classes.removeBtn}>
            <Button
              icon={TrashIconGray}
              onClick={() => removePhotoOrVideo(item)}
              primary={false}
              customStyle={{
                width: "36px",
                height: "36px",
                backgroundColor: Colors.white,
                border: "none",
                padding: "8px",
              }}
            />
          </div>
        </div>
      )}
      {isVideo && (
        <div className={classes.multipleVideoCard}>
          <video src={URL.createObjectURL(item)} controls={true} />
          <div className={classes.removeBtn}>
            <Button
              icon={TrashIconGray}
              onClick={() => removePhotoOrVideo(item)}
              primary={false}
              customStyle={{
                width: "36px",
                height: "36px",
                backgroundColor: Colors.white,
                border: "none",
                padding: "8px",
              }}
            />
          </div>
        </div>
      )}{" "}
    </>
  );
}
